"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IDENTITY_RESOLUTION_CANDIDATE_RESPONSE_EXAMPLE = void 0;
exports.IDENTITY_RESOLUTION_CANDIDATE_RESPONSE_EXAMPLE = {
    id: '77777777-7777-7777-7777-777777777777',
    tenantId: '11111111-1111-1111-1111-111111111111',
    patientAId: '22222222-2222-2222-2222-222222222222',
    patientBId: '33333333-3333-3333-3333-333333333333',
    matchTier: 'STRONG_MATCH',
    matchScore: 70,
    scorerVersion: '2026.1',
    status: 'PENDING_REVIEW',
    reviewedBy: null,
    reviewedAt: null,
    mergeRecommended: false,
    mergeId: null,
    createdAt: '2026-07-10T09:00:00.000Z',
    updatedAt: '2026-07-10T09:00:00.000Z',
};
//# sourceMappingURL=identity-resolution.response.js.map